import React, { useEffect, useState } from "react";
import { useSaveProfessionalOfficePhotoMutation } from "../../store/professionalInfo";
// import { useSaveAdminProfessionalOfficePhotoMutation } from "../../../../../store/admin/professionalUserInfo";

import imageCompression from "browser-image-compression";
import { useSaveAdminProfessionalOfficePhotoMutation } from "../../store/admin/professionalUserInfo";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const OfficePhotoUpload = ({ photos, setUpdatedImages,isAdmin=false, user_id }) => {
  const [uploadedImages, setUploadedImages] = useState(photos ?? []);
  const [deleteOfficePhoto] = useSaveProfessionalOfficePhotoMutation();
    const [
      saveProfessionalOfficePhoto,
      { isLoading: photosLoader, isSuccess: photosSuccess },
    ] = useSaveAdminProfessionalOfficePhotoMutation();
  
  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  useEffect(() => {
    if (photos && photos.length > 0) {
      setUploadedImages(photos);
    }
  }, [photos]);

  const handleImageUpload = (value) => {
    if (value && value.name) {
      return URL.createObjectURL(value);
    } else {
      return `${baseUrl}storage/` + value;
    }
  };

  const compressImage = async (file) => {
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 500,
        useWebWorker: true,
      };
      return await imageCompression(file, options);
    } catch (error) {
      console.error("Image compression error:", error);
    }
  };

  const handleFileUpload = async (event) => {
    const files = event.target.files;
    if (uploadedImages.length > 5) {
      event.target.disabled = true;
      return;
    }

    if (files.length > 0) {
      let tempPhotos = [];
      let count = 6 - uploadedImages.length;
      for (let i = 0; i < count; i++) {
        if (files[i]) {
          const compressedFile = await compressImage(files[i]);
          tempPhotos.push(compressedFile);
        }
      }

      setUploadedImages([...uploadedImages, ...tempPhotos]);
      setUpdatedImages && setUpdatedImages([...uploadedImages, ...tempPhotos]);
    }
    if (files.length + uploadedImages.length > 5) {
      event.target.disabled = true;
      return;
    }
  };

  const handleDeleteImage = (index, image) => {
    if (photos.length > 0 && image.photo) {
      const params = {
        _method: "DELETE",
        officePhotos: [image.id],
      };
      if(isAdmin)
      { 
         delete params.officePhotos
         params.user_id = user_id
         params["office_photos"]= [image.id]
        saveProfessionalOfficePhoto && saveProfessionalOfficePhoto(params)
      }
      else 
      {
        deleteOfficePhoto && deleteOfficePhoto(params);

      }
    }

    const updatedImages = [...uploadedImages];
    updatedImages.splice(index, 1);
    setUploadedImages(updatedImages);
    setUpdatedImages && setUpdatedImages(updatedImages);

    if (updatedImages.length >= 5) {
      document.getElementById("office-file-upload").disabled = false;
    }
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (uploadedImages.length > 5) {
      event.target.disabled = true;
      return;
    }
    if (files.length > 0) {
      let tempPhotos = [];
      let count = 6 - uploadedImages.length;
      for (let i = 0; i < count; i++) {
        if (files[i]) {
          const compressedFile = await compressImage(files[i]);
          tempPhotos.push(compressedFile);
        }
      }

      setUploadedImages([...uploadedImages, ...tempPhotos]);
      setUpdatedImages && setUpdatedImages([...uploadedImages, ...tempPhotos]);
    }

    if (files.length + uploadedImages.length > 5) {
      event.target.disabled = true;
      return;
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <div className="py-6">
        <div
          className="flex justify-center rounded-[10px] bg-[#EBF7FF] border border-dashed border-primary px-5 py-[30px]"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <div className="text-center">
            <div className="flex text-sm leading-6 text-gray-600">
              <p className="text-sm font-medium leading-[160%] text-customGray mb-[5px]">
                {!isMobile && "Drag and Drop or "}
                <label
                  htmlFor="office-file-upload"
                  className="relative cursor-pointer underline text-primary"
                >
                  <span>Choose Photo(s)</span>
                  <input
                    id="office-file-upload"
                    name="office-file-upload"
                    type="file"
                    className="sr-only"
                    onChange={handleFileUpload}
                    multiple
                  />
                </label>{" "}
                of your office to Upload
              </p>
            </div>
            <p className="text-sm leading-[160%] text-[#485868]">
              Maximum File Size 10 MB
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-[18px]">
        {uploadedImages &&
          uploadedImages.map((image, index) => (
            <div key={index} className="relative">
              <img
                src={handleImageUpload(image.photo ?? image)}
                alt=""
                className="rounded-[10px] h-[96px] md:h-[138px] w-full object-cover"
              />
              <button
                onClick={() => handleDeleteImage(index, image)}
                className="w-6 h-6 rounded-md p-[6px] bg-white absolute right-1 bottom-1.5 flex items-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M9 3L3 9"
                      stroke="#EF2121"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 3L9 9"
                      stroke="#EF2121"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          ))}
      </div>
    </>
  );
};

export default OfficePhotoUpload;
